<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card v-if="trip != null">
      <ODialogBar title="Ajustar Datas" @close="dismiss" />
      <v-card-text class="pa-6">
        <div class="d-flex align-center justify-space-between mb-6">
          <div class="w-100">
            Início
          </div>
          <div class="w-200 text-right">
            {{ trip.startTimestamp | moment }}
          </div>
          <div class="w-300">
            <ODateTimeInput2 v-model="newStartTimestamp" :clearable="false" />
          </div>
          <div class="w-50">
            <AdjustDeltaPicker @input="(v) => addStart(v)" />
          </div>
        </div>

        <div class="d-flex align-center justify-space-between mb-6">
          <div class="w-100">
            Duração
          </div>
          <div class="w-200 text-right">
            ({{ trip.lapseCount }} lapsos)

            <v-btn icon class="mx-2" @click="newDurationS = trip.lapseCount">
              <v-icon>mdi-arrow-right-bold-outline</v-icon>
            </v-btn>
          </div>
          <div class="w-300">
            <OTextField v-model="newDurationS" :suffix="newDurationStr" />
          </div>
          <div class="w-50">
            <AdjustDeltaPicker @input="(v) => addDuration(v)" />
          </div>
        </div>

        <div class="d-flex align-center justify-space-between mb-6">
          <div class="w-100">
            Fim
          </div>
          <div class="w-200 text-right">
            {{ trip.endTimestamp | moment }}
          </div>
          <div class="w-300">
            <ODateTimeInput2 v-model="newEndTimestamp" :clearable="false" />
          </div>
          <div class="w-50">
            <AdjustDeltaPicker @input="(v) => addEnd(v)" />
          </div>
        </div>
      </v-card-text>
      <v-card-text class="pa-6 amber">
        <v-btn small @click="copyToClipboard" class="mb-4">
          <v-icon small>mdi-clipboard</v-icon>
          Copiar para o Clipboard
        </v-btn>
        <pre class="mono">{{ sql }}</pre>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { OrgApi } from '@/models'
import moment from 'moment'
import formatters from 'oderon-commons/src/formatters.js'
import AdjustDeltaPicker from './AdjustDeltaPicker.vue'

function addS(x, ds) {
  return moment(x)
    .add(ds, 'seconds')
    .toDate()
}

function mysqlDt(x) {
  return moment(x).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
}

function same(a, b) {
  return moment(a).isSame(b, 'second')
}

export default {
  components: { AdjustDeltaPicker },
  data() {
    return {
      orgId: null,
      tripId: null,
      trip: null,
      newStartTimestamp: null,
      newDurationS: null,
      newEndTimestamp: null,
      startDeltaS: 0,
      endDeltaS: 0,
      changeStart: false,
      changeDur: false,
      changeEnd: false
    }
  },
  watch: {
    newStartTimestamp() {
      this.updateEnd()
    },
    newDurationS() {
      this.updateEnd()
    }
  },
  computed: {
    newDurationStr() {
      if (this.newDurationS == null) return null
      return formatters.sDuration(this.newDurationS)
    },
    sql() {
      let what = []
      if (!same(this.trip.startTimestamp, this.newStartTimestamp))
        what.push(`\`startTimestamp\` = '${mysqlDt(this.newStartTimestamp)}'`)

      if (this.trip.durationS != this.newDurationS)
        what.push(`\`durationS\`      = '${this.newDurationS}'`)

      if (!same(this.trip.endTimestamp, this.newEndTimestamp))
        what.push(`\`endTimestamp\`   = '${mysqlDt(this.newEndTimestamp)}'`)

      what = '\n' + what.join(',\n')
      return `UPDATE \`Trips\` SET ${what}\nWHERE \`id\` = ${this.tripId};`
    }
  },
  methods: {
    open({ orgId, tripId }) {
      this.orgId = orgId
      this.tripId = tripId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchData() {
      let fetcher = new OrgApi(this.orgId)
      let trip = await fetcher.get('trips/' + this.tripId)
      this.trip = trip
      trip.startTimestamp = moment(trip.startTimestamp).toDate()
      trip.endTimestamp = moment(trip.endTimestamp).toDate()
      this.newStartTimestamp = trip.startTimestamp
      this.newDurationS = trip.durationS
      this.newEndTimestamp = trip.endTimestamp
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.sql)
      this.$snack(`SQL copiado`)
    },

    addStart(ds) {
      this.newStartTimestamp = addS(this.newStartTimestamp, ds)
      this.updateEnd()
    },

    addDuration(ds) {
      this.newDurationS += ds
      this.updateEnd
    },

    updateEnd() {
      this.newEndTimestamp = addS(this.newStartTimestamp, this.newDurationS)
    }
  }
}
</script>

<style></style>
